import { Component, Input, OnInit } from '@angular/core';

import { StateService } from '@uirouter/angular';
import { FrsReportHelper } from './project.report.frs.service.component';
import { ProjectService } from '../../../../services/project.service';
import { FilterService } from '../../../../services/core.filter.service';
import { UiService } from '../../../../services/core.ui.service';
import { ProjectReportsData } from '../../services/project.reports.data.service';
import { GfTranslateService } from '../../../../services/core.translate.service';

import * as _ from 'lodash';
import * as d3 from 'd3';

@Component({
    selector: 'project-frs-report',
    template: require('./project.report.frs.component.html')
})
export class ProjectFrsReportComponent implements OnInit {
    protected criteriaDesc = '';

    @Input() project: any = null;
    @Input() packages: any = [];

    protected charts: any = false;
    protected detail: any = null;
    protected sortFields: any = false;
    private baseFilters: any = null;
    protected filters: any = {};
    private currents: any = {
        user: false, package: false, release: false
    };
    protected dateChartOptions: any = null;
    protected pieChartOptions: any = null;

    constructor(
        private stateService: StateService, 
        
        private frsReportHelper: FrsReportHelper,
        private projectService: ProjectService,
        private filterService: FilterService,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService,
        private projectReportsData: ProjectReportsData,
    ) { }

    ngOnInit() {
        this.dateChartOptions = {
            chart: {
                type: 'multiBarChart',
                showControls: false,
                height: 350,
                margin: {
                    top: 20,
                    right: 30,
                    bottom: 65,
                    left: 65
                },
                showLegend: false,
                noData: this.gfTranslateService.translate("No Data Available"),
                color: ['#99CC33'],
                x: (d) => {
                    return d.x;
                },
                y: (d) => {
                    return d.y;
                },
                valueFormat: d3.format(""),
                xAxis: {
                    axisLabel: this.gfTranslateService.translate("Date"),
                    rotateLabels: -30
                },
                yAxis: {
                    axisLabel: this.gfTranslateService.translate("Download Count"),
                    tickFormat: (d) => {
                        var ret = parseInt(d);
                        if (d - ret > .01) return '';
                        return ret;
                    }
                }
            }
        };

        this.pieChartOptions = {
            chart: {
                type: 'pieChart',
                height: 360,
                noData: this.gfTranslateService.translate("No Data Available"),
                x: (d) => { return d.key; },
                y: (d) => { return d.y; },
                valueFormat: d3.format(""),
                transitionDuration: 200,
                showLabels: false,
                labelThreshold: 0.01,
                showLegend: true,
                legendPosition: 'bottom'
            }
        };
        this.baseFilters = this.frsReportHelper.getBaseFilters(this.packages);
        this.filters = {
            main_fields: this.frsReportHelper.setFiltersFromStateParams(_.cloneDeep(this.baseFilters), this.stateService.params)
        };
        this.refreshData();
    };

    resetFilters = () => {
        this.filters = {
            main_fields: _.cloneDeep(this.baseFilters)
        };
        this.applyFilters();
    };

    downloadData(format) {
        this.projectReportsData.runReport(this.getParams(), format);
    };

    refreshData = () => {
        this.charts = false;

        const params = this.getParams();

        this.projectService.report(params)
            .then(
                (response) => {
                    this.charts = this.frsReportHelper.createChartData(
                        _.get(response, 'items', [])
                    );

                    this.detail = this.frsReportHelper.getDetailTable(
                        _.get(response, 'items.detail', [])
                    );
                },
                () => {
                    this.charts = {};
                    var msg = this.gfTranslateService.translate('There was a problem loading scm commits data', this.stateService.params);
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            );
    };

    setCurrent(name, value) {
        var cur = _.get(this.currents, name);
        _.set(this.currents, name, value);
        return cur != value;
    }

    getParams(overrides = {}) {
        var ret = Object.assign(
            { project: this.stateService.params.unixName, type: this.stateService.params.type },
            this.filterService.getAllFilterValues(
                _.get(this.filters, 'main_fields', []),
            ),
            overrides || {}
        );
        return ret;
    }

    applyFilters = (overrides = {}) => {
        var params = this.getParams(overrides);
        var opts = { reload: false, location: true, notify: false };
        this.stateService.go('.', params, opts).then(this.refreshData);
    }
}